import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const BreadcrumbButton = styled.button<{ isDisabled: boolean }>`
  background: none;
  border: none;
  outline: none;
  font-size: 12px;
  color: ${({ isDisabled }) => (isDisabled ? '#666' : '#444')};
  opacity: ${({ isDisabled }) => (!isDisabled ? 1 : 0.6)};
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  letter-spacing: 0em;
  padding: 0;

  &:after {
    content: '›';
    margin: 0px 7px;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  &:last-child:after {
    content: '';
  }
`;

export const Wrapper = styled.div`
  margin: 14px 0 0px;

  ${media.md`
    margin: 14px 0 8px;
  `};
`;
